import { render, staticRenderFns } from "./child-platform.vue?vue&type=template&id=22997104&scoped=true"
import script from "./child-platform.vue?vue&type=script&lang=js"
export * from "./child-platform.vue?vue&type=script&lang=js"
import style0 from "./child-platform.vue?vue&type=style&index=0&id=22997104&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22997104",
  null
  
)

export default component.exports